import {
  OptionGroupButton,
  OptionGroupCheckIcon,
  OptionGroupCheckbox,
  OptionGroupHint,
  OptionGroupItemHint,
  OptionGroupItemLabel,
  OptionGroupLabel,
  OptionGroupList,
  OptionGroupRadio,
  OptionGroupRequiredMark,
  OptionGroupText,
} from "./CheckboxGroupField.styles";

const CheckboxGroupField = ({
  name,
  label,
  value,
  required,
  disabled,
  error,
  hint,
  options = [],
  onChange,
  multiple = true,
  field = {},
}) => {
  const isMultiple = field.multiple ?? multiple;
  const labelId = field.labelId || `${name}-label`;
  const testIdPrefix = field.testIdPrefix;
  const selectedValues = isMultiple
    ? (Array.isArray(value) ? value : []).map(String)
    : [];
  const selectedValue = isMultiple ? "" : String(value ?? "");

  const handleClick = (optionValue) => {
    if (disabled) return;
    if (!isMultiple) {
      onChange(name, optionValue);
      return;
    }
    const currentlySelected = selectedValues.includes(optionValue);
    onChange(
      name,
      currentlySelected
        ? selectedValues.filter((item) => item !== optionValue)
        : [...selectedValues, optionValue]
    );
  };

  return (
    <>
      {label ? (
        <OptionGroupLabel id={labelId} component="span">
          {label}
          {required ? (
            <>
              {" "}
              <OptionGroupRequiredMark>*</OptionGroupRequiredMark>
            </>
          ) : null}
        </OptionGroupLabel>
      ) : null}
      <OptionGroupList
        role={isMultiple ? "group" : "radiogroup"}
        aria-labelledby={labelId}
      >
        {options.map((option) => {
          const optionValue = String(option.value ?? option);
          const optionLabel = String(option.label ?? option.value ?? option);
          const checked = isMultiple
            ? selectedValues.includes(optionValue)
            : selectedValue === optionValue;
          return (
            <OptionGroupButton
              key={optionValue}
              type="button"
              role={isMultiple ? "checkbox" : "radio"}
              aria-checked={checked}
              aria-label={optionLabel}
              data-testid={
                testIdPrefix ? `${testIdPrefix}-${optionValue}` : undefined
              }
              disabled={disabled}
              onClick={() => handleClick(optionValue)}
            >
              {isMultiple ? (
                <OptionGroupCheckbox $checked={checked}>
                  {checked ? <OptionGroupCheckIcon /> : null}
                </OptionGroupCheckbox>
              ) : (
                <OptionGroupRadio $checked={checked} />
              )}
              <OptionGroupText>
                <OptionGroupItemLabel component="span">
                  {optionLabel}
                </OptionGroupItemLabel>
                {option.hint ? (
                  <OptionGroupItemHint component="span">
                    {option.hint}
                  </OptionGroupItemHint>
                ) : null}
              </OptionGroupText>
            </OptionGroupButton>
          );
        })}
      </OptionGroupList>
      {error || hint ? (
        <OptionGroupHint
          component="div"
          role={error ? "alert" : undefined}
          $error={Boolean(error)}
        >
          {error || hint}
        </OptionGroupHint>
      ) : null}
    </>
  );
};

export default CheckboxGroupField;
